export default __webpack_public_path__ + "static/media/Wreath of Vapors.0338767c.jpg";